export default __webpack_public_path__ + "static/1.1_DE-aeb98966253e545eb251811180748dfd.png";